import React from 'react';

import { useCustomerInformationWidgetQuery } from 'generated/graphql';



export interface IAddress {
  addressee?: string | null;
  street1: string;
  street2: string;
  city: string;
  usState: string;
  postalCode: string;
  countryCode: string;
  company: string;
  phone: string;
}

export interface ICustomer {
  fullName: string;
  email: string;
  phoneNumber: string;
}

export interface IOrder {
  customer: ICustomer;
  billingAddress: IAddress;
  shippingAddress: IAddress;
}

export interface IData {
  order: IOrder | null;
}

export function useQuery(orderId: string) {
  const queryTuple = useCustomerInformationWidgetQuery({
    variables: {
      orderId
    }
  });



  return React.useMemo(
    () => {
      const order = queryTuple.data?.order;
      if (!order) {
        return {
          ...queryTuple,
          data: {
            order: null
          }
        };
      }

      const customer = order?.customer;
      const data: IData = {
        order: {
          customer: {
            fullName: customer.firstName + ' ' + customer.lastName,
            email: customer.email,
            phoneNumber: customer.phoneNumber
          },
          billingAddress: order.billingAddress,
          shippingAddress: order.shippingAddress
        }
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]);
}
